import { render, staticRenderFns } from "./-InstagramPosts.vue?vue&type=template&id=4e1454a4&scoped=true&"
import script from "./-InstagramPosts.vue?vue&type=script&lang=js&"
export * from "./-InstagramPosts.vue?vue&type=script&lang=js&"
import style0 from "./-InstagramPosts.vue?vue&type=style&index=0&id=4e1454a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1454a4",
  null
  
)

export default component.exports